// Add to RegExp prototype
RegExp.prototype.execAll = function (string) {
    let match = null;
    const matches = [];
    while ((match = this.exec(string))) {
        const matchArray = [];
        for (const i in match) {
            if (parseInt(i) == i) {
                matchArray.push(match[i]);
            }
        }
        matches.push(matchArray);
    }
    return matches;
};
